const API_BASE = process.env.REACT_APP_API_BASE || "/api";

async function request(path, opts = {}) {
  const res = await fetch(API_BASE + path, opts);
  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

// Public APIs
export async function getAllBlogs({
  page = 1,
  limit = 10,
  status = "published",
  category = null,
} = {}) {
  let url = `/blogs?page=${page}&limit=${limit}&status=${status}`;
  if (category) {
    url += `&category=${category}`;
  }
  return request(url);
}

export async function getBlogBySlug(slug) {
  return request(`/blogs/${slug}`);
}

// Admin APIs
export async function createBlog({
  title,
  full_description,
  short_description,
  image,
  author,
  category,
  tags,
  status,
  token,
}) {
  const body = {
    title,
    full_description,
    short_description,
    image,
    author,
    category,
    tags: tags || [],
    status: status || "published",
  };

  return request("/blogs", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
}

export async function updateBlog({
  id,
  title,
  full_description,
  short_description,
  image,
  author,
  category,
  tags,
  status,
  token,
}) {
  const body = {
    title,
    full_description,
    short_description,
    image,
    author,
    category,
    tags: tags || [],
    status,
  };

  return request(`/blogs/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(body),
  });
}

export async function deleteBlog({ id, token }) {
  return request(`/blogs/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export async function getBlogStats({ token }) {
  return request("/blogs/admin/stats/overview", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

// Upload blog image to S3 or local storage
export async function uploadBlogImage({ file, token }) {
  const form = new FormData();
  form.append("image", file);

  const res = await fetch(API_BASE + "/blogs/upload", {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });

  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}
